//eslint:disable max-func-body-length
import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodeNode, CodeParent } from 'app/area/codetable/item/code-pickers';
import { CodeCategory } from 'app/area/codetable/item/code-pickers/code-category';
import { CodeSequence } from 'app/area/codetable/item/code-fields/code-sequence';
import { CodeDisabled } from 'app/area/codetable/item/code-fields/code-disabled';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { shouldRenderDetails } from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { CodeIcon } from 'app/area/codetable/item/code-fields/code-icon';
import { CodeColour } from 'app/area/codetable/item/code-pickers/code-colour';
import { ReadOnlyType, SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';

export const Details = (props: Partial<CodetableItemFormComponentProps> & SlotProps) => {

  const { translation, metadata, codeItem, breadcrumbs, validation, codetableOptions, sectionSlots, actionType, loadOptions,
    loadCodetableOptions, updateListNode, sectionRef, readOnlyConfig, updateIcon, updateColourCode,
    options, updateCodeCategory, updateParent, updateSequence, locale, updateDisabled,
    fetchingParentCategory } = props;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return shouldRenderDetails(metadata, sectionSlots)
    ? <div ref={sectionRef}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId="details"
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <CodeCategory
            actionType={actionType}
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            breadcrumbs={breadcrumbs}
            validation={validation}
            options={codetableOptions}
            loadOptions={loadCodetableOptions}
            translation={translation}
            fetchingParentCategory={fetchingParentCategory}
            onChange={updateCodeCategory}
          />
          {renderSlot(sectionSlots, 'top', props)}
          <CodeNode
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            breadcrumbs={breadcrumbs}
            validation={validation}
            options={codetableOptions}
            translation={translation}
            loadOptions={loadCodetableOptions}
            onChange={updateListNode}
          />
          <CodeParent
            actionType={actionType}
            readOnly={readOnly || (readOnlyConfig && readOnlyConfig[ReadOnlyType.codeParent])}
            metadata={metadata}
            codeItem={codeItem}
            breadcrumbs={breadcrumbs}
            validation={validation}
            options={codetableOptions}
            translation={translation}
            loadOptions={loadCodetableOptions}
            onChange={updateParent}
          />
          <CodeSequence
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            onChange={updateSequence}
            translation={translation} />
          <CodeColour
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            options={options}
            loadOptions={loadOptions}
            onChange={updateColourCode}
            translation={translation} />
          <CodeIcon
            readOnly={readOnly}
            validation={validation}
            metadata={metadata}
            codeItem={codeItem}
            onChange={updateIcon}
            translation={translation} />
          <CodeDisabled
            metadata={metadata}
            disabled={codeItem && codeItem.disabled}
            readOnly={readOnly}
            locale={locale}
            onChange={updateDisabled}
            validation={validation}
            translation={translation} />
          {renderSlot(sectionSlots, 'bottom', props)}
        </div>
      </MainGridContainer>
    </div> : null;

};
